module.exports = {"430726001":"楚江街道","430726002":"永兴街道","430726003":"宝峰街道","430726004":"二都街道","430726101":"蒙泉镇","430726102":"夹山镇","430726103":"易家渡镇","430726104":"新关镇","430726105":"皂市镇","430726106":"维新镇","430726107":"太平镇","430726108":"磨市镇","430726109":"壶瓶山镇","430726110":"南北镇","430726111":"白云镇","430726112":"新铺镇","430726113":"子良镇","430726203":"三圣乡","430726205":"所街乡","430726206":"雁池乡","430726207":"罗坪乡","430726500":"秀坪园艺场","430726502":"东山峰管理区","430726503":"大同山林场","430726504":"白云山林场","430726505":"洛浦寺林场","430726506":"夹山管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430726.json
// module id = 2002
// module chunks = 0